export default __webpack_public_path__ + "static/media/apple-developer-merchantid-domain-association.30525ea7.bin";